import { Component, Show } from 'solid-js'
import './InappropriateContentModal.css'

interface InappropriateContentModalProps {
  show: boolean
  onClose: () => void
  /** Full server error string, e.g. "Message contains inappropriate content: young" */
  content?: string
  /** Kept for backward compatibility — not rendered */
  message?: string
}

/**
 * Parse the flagged term from a server error string.
 * "Message contains inappropriate content: young" → "young"
 * "Message contains inappropriate content: young, kill" → "young"  (first term only)
 * "Message contains inappropriate content"        → null  (pill hidden per spec)
 */
const parseFlaggedTerm = (errorStr: string | undefined): string | null => {
  if (!errorStr) return null
  const idx = errorStr.lastIndexOf(':')
  if (idx === -1) return null
  const term = errorStr.slice(idx + 1).trim()
  // When server returns multiple terms (comma-separated), show only the first
  const firstTerm = term.split(',')[0].trim()
  return firstTerm || null
}

const InappropriateContentModal: Component<InappropriateContentModalProps> = (props) => {
  const term = () => parseFlaggedTerm(props.content)

  return (
    <Show when={props.show}>
      {/* backdrop-filter applied inline: autoprefixer strips the unprefixed property */}
      <div
        class="cf-mod-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cf-mod-title"
        style={{ 'backdrop-filter': 'blur(14px)', '-webkit-backdrop-filter': 'blur(14px)' }}
        onClick={(e) => {
          if (e.target === e.currentTarget) props.onClose()
        }}
      >
        <div class="cf-mod-card">
          <button class="cf-mod-close" onClick={() => props.onClose()} aria-label="Close">
            ×
          </button>

          <div class="cf-mod-badge">
            <svg
              viewBox="0 0 24 24"
              width="34"
              height="34"
              fill="none"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" />
              <path d="M12 8v4" />
              <circle cx="12" cy="15.5" r="0.6" fill="#fff" stroke="none" />
            </svg>
          </div>

          <div class="cf-mod-eyebrow">Content Policy</div>
          <h2 id="cf-mod-title" class="cf-mod-title">
            Message Blocked
          </h2>
          <p class="cf-mod-body">
            To keep CosplayFans safe, this message can't be sent — it contains a restricted term.
          </p>

          <Show when={term()}>
            {(t) => (
              <div class="cf-mod-flag">
                <span class="cf-mod-flag-dot" />
                Flagged term: <b>{t()}</b>
              </div>
            )}
          </Show>

          <button class="cf-mod-btn" onClick={() => props.onClose()}>
            Got it
          </button>

          <p class="cf-mod-fine">Edit your message and try again.</p>
        </div>
      </div>
    </Show>
  )
}

export default InappropriateContentModal
